import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9, default as _styled10, default as _styled11, default as _styled12, default as _styled13, default as _styled14, default as _styled15, default as _styled16, default as _styled17, default as _styled18, default as _styled19, default as _styled20, default as _styled21, default as _styled22, default as _styled23, default as _styled24, default as _styled25, default as _styled26 } from "styled-components";
import React from "react";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { Headline } from "~/features/ui/headline";
import { getThemeStyle } from "~/features/ui/get-theme-style";
import { Grid } from "~/features/ui/grid";
import { RichText } from "~/features/ui/rich-text";
import { Wrap } from "~/features/ui/wrap";
import { Media } from "~/features/ui/media";
import { takeFirst, hasItems } from "~/features/app/utils";
import { VideoControls } from "~/features/ui/video/video-controls";
import { type LinkProps, Link } from "~/features/ui/link";
import { isLinkValid } from "~/features/ui/link/utils";
import { Icon } from "~/features/ui/icon";
import { Button } from "~/features/ui/button";
import { useLinkIcon } from "~/features/ui/link/use-link-icon";
import { useNavLayout } from "~/features/app/app-header-v2/context";
import ArrowLeft from "~/public/icons/arrow-left.svg";
const fragment = graphql(`
  fragment SimpleHero on hero_simpleHero_BlockType {
    headline: baseHeadline
    text: baseRichText
    media: baseMedia {
      ...Media
    }
    link: baseLink {
      ...Link
    }
    layout: simpleHeroLayout
    mediaLayout: simpleHeroMediaLayout
  }
`);
const layouts = {
  full: SimpleHeroFull,
  "1/3": SimpleHero1_3
} as const;
const mediaLayoutVariants = {
  full: {
    "width": "100%"
  },
  large: {
    "@media (min-width: 1024px)": {
      "marginLeft": "auto",
      "marginRight": "auto",
      "width": "75%",
      "borderLeftWidth": "1px",
      "borderRightWidth": "1px"
    }
  },
  medium: {
    "@media (min-width: 1024px)": {
      "marginLeft": "auto",
      "marginRight": "auto",
      "width": "50%",
      "borderLeftWidth": "1px",
      "borderRightWidth": "1px"
    }
  }
} as const;
type MediaLayout = keyof typeof mediaLayoutVariants;
type Props = FragmentType<typeof fragment> & {
  backLink?: LinkProps;
  block?: React.ReactNode;
  tags?: React.ReactNode;
  metadata?: React.ReactNode;
};
export function SimpleHero1_3(props: Props) {
  const {
    backLink,
    block,
    metadata,
    ...rest
  } = props;
  const {
    headline,
    text,
    media: _media,
    link,
    mediaLayout = "full"
  } = useFragment(fragment, rest);
  const themeStyle = getThemeStyle({
    mode: "light"
  });
  const media = takeFirst(_media);
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const {
    isAnnouncementBarVisible
  } = useNavLayout();
  const cta = takeFirst(link);
  const linkIcon = useLinkIcon(cta || undefined);
  const topSpacing = isAnnouncementBarVisible ? {
    "marginTop": "calc(var(--header-height) + var(--announcement-bar-height))"
  } : {
    "marginTop": "var(--header-height)"
  };
  // v3: hero surfaces render true white (the theme helper maps "white" to grey-20).
  const surface = {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
  };
  return <_StyledDiv $_css={[{
    "borderTopWidth": "0px !important"
  }, topSpacing, surface, themeStyle.border]}>
      <_StyledWrap mode="light">
        <_StyledGrid $_css2={[{
        "> :not([hidden]) ~ :not([hidden])": {
          "--tw-divide-x-reverse": "0",
          "borderRightWidth": "calc(1px * var(--tw-divide-x-reverse))",
          "borderLeftWidth": "calc(1px * calc(1 - var(--tw-divide-x-reverse)))"
        },
        "@media (min-width: 1920px)": {
          "> :not([hidden]) ~ :not([hidden])": {
            "--tw-divide-x-reverse": "0",
            "borderRightWidth": "calc(0px * var(--tw-divide-x-reverse))",
            "borderLeftWidth": "calc(0px * calc(1 - var(--tw-divide-x-reverse)))"
          }
        }
      }, themeStyle.border]}>
          <_StyledDiv2 $_css3={[{
          "position": "relative",
          "zIndex": "10",
          "gridColumn": "span 4 / span 4",
          "@media (min-width: 1280px)": {
            "gridColumn": "span 3 / span 3",
            "paddingLeft": "var(--spacing-xl)"
          },
          "@media (min-width: 1536px)": {
            "gridColumn": "span 4 / span 4"
          }
        }, surface]}>
            <_StyledDiv3 $_css4={[{
            "display": "flex",
            "height": "100%",
            "flexDirection": "column",
            "alignItems": "flex-start",
            "rowGap": "var(--spacing-lg)",
            "@media (min-width: 1024px)": {
              "borderLeftWidth": "1px",
              "padding": "var(--spacing-xl)"
            }
          }, themeStyle.border]}>
              {backLink && <Button as={Link} variant="underline" href={`${process.env.NEXT_PUBLIC_URL}/${backLink.href}`}>
                  <_StyledIcon icon={ArrowLeft} size="16" />
                  {backLink.text}
                </Button>}
              {headline && <_StyledDiv4 $_css5={[{
              "width": "100%",
              "borderBottomWidth": "1px",
              "paddingLeft": "var(--spacing-xl)",
              "paddingRight": "var(--spacing-xl)",
              "paddingTop": "var(--spacing-lg)",
              "paddingBottom": "var(--spacing-lg)",
              "@media (min-width: 1024px)": {
                "borderWidth": "0px",
                "padding": "0"
              }
            }, themeStyle.border]}>
                  <_StyledHeadline text={headline} />
                </_StyledDiv4>}
              {(text || isLinkValid(cta)) && <_StyledDiv5 $_css6={[{
              "display": "flex",
              "width": "100%",
              "flexDirection": "column",
              "alignItems": "flex-start",
              "rowGap": "var(--spacing-lg)",
              "borderBottomWidth": "1px",
              "paddingLeft": "var(--spacing-xl)",
              "paddingRight": "var(--spacing-xl)",
              "paddingBottom": "var(--spacing-lg)",
              "@media (min-width: 1024px)": {
                "borderWidth": "0px",
                "padding": "0"
              }
            }, themeStyle.border]}>
                  {text && <RichText text={text} />}
                  {isLinkValid(cta) && <Button as={Link} {...cta} variant="underline" icon={linkIcon} />}
                </_StyledDiv5>}
            </_StyledDiv3>
          </_StyledDiv2>
          <_StyledDiv6>
            <_StyledDiv7 $_css7={[{
            "@media (min-width: 1024px)": {
              "borderRightWidth": "1px"
            },
            "@media (min-width: 1800px)": {
              "paddingRight": "var(--spacing-xl)"
            }
          }, themeStyle.border]}>{block}</_StyledDiv7>
          </_StyledDiv6>
        </_StyledGrid>
        {metadata}
        {hasItems(media) && <_StyledDiv8 $_css8={[{
        "borderTopWidth": "1px"
      }, themeStyle.border]}>
            <_StyledDiv9 $_css9={[{
          "padding": "var(--spacing-md)",
          "@media (min-width: 1024px)": {
            "padding": "var(--spacing-xl)"
          }
        }, mediaLayoutVariants[mediaLayout as MediaLayout], themeStyle.border]}>
              <Media {...takeFirst(media)} imageProps={{
            ratio: "16/9",
            loading: "eager",
            priority: true
          }} inlineVideoProps={{
            ratio: "16/9",
            videoRef: videoRef,
            priority: true,
            controls: <_StyledVideoControls videoRef={videoRef} />
          }} externalVideoProps={{
            ratio: "16/9"
          }} />
            </_StyledDiv9>
          </_StyledDiv8>}
      </_StyledWrap>
    </_StyledDiv>;
}
export function SimpleHeroFull(props: Props) {
  const {
    backLink,
    block,
    tags,
    metadata,
    ...rest
  } = props;
  const {
    headline,
    text,
    media: _media,
    link,
    mediaLayout = "full"
  } = useFragment(fragment, rest);
  const themeStyle = getThemeStyle({
    mode: "light"
  });
  const media = takeFirst(_media);
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const {
    isAnnouncementBarVisible
  } = useNavLayout();
  const cta = takeFirst(link);
  const linkIcon = useLinkIcon(cta || undefined);
  const topSpacing = isAnnouncementBarVisible ? {
    "marginTop": "calc(var(--header-height) + var(--announcement-bar-height))"
  } : {
    "marginTop": "var(--header-height)"
  };
  // v3: hero surfaces render true white (the theme helper maps "white" to grey-20).
  const surface = {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
  };
  return <_StyledDiv10 $_css10={[{
    "borderTopWidth": "0px !important"
  }, topSpacing, surface, themeStyle.border]}>
      <Wrap mode="light">
        {backLink && <_StyledDiv11 $_css11={[{
        "position": "relative",
        "zIndex": "10"
      }, surface]}>
            <_StyledDiv12 $_css12={[{
          "display": "flex",
          "height": "var(--header-height)",
          "alignItems": "center",
          "borderBottomWidth": "1px",
          "paddingLeft": "var(--spacing-lg)",
          "paddingRight": "var(--spacing-lg)",
          "@media (min-width: 1024px)": {
            "paddingLeft": "var(--spacing-3xl)",
            "paddingRight": "var(--spacing-3xl)"
          }
        }, themeStyle.border]}>
              <Button as={Link} variant="underline" href={`${process.env.NEXT_PUBLIC_URL}/${backLink.href}`}>
                <_StyledIcon2 icon={ArrowLeft} size="16" />
                {backLink.text}
              </Button>
            </_StyledDiv12>
          </_StyledDiv11>}
        <_StyledGrid2 $_css13={[{
        "position": "relative",
        "zIndex": "10",
        "@media (min-width: 1024px)": {
          "> :not([hidden]) ~ :not([hidden])": {
            "--tw-divide-x-reverse": "0",
            "borderRightWidth": "calc(1px * var(--tw-divide-x-reverse))",
            "borderLeftWidth": "calc(1px * calc(1 - var(--tw-divide-x-reverse)))",
            "--tw-divide-y-reverse": "0",
            "borderTopWidth": "calc(0px * calc(1 - var(--tw-divide-y-reverse)))",
            "borderBottomWidth": "calc(0px * var(--tw-divide-y-reverse))"
          }
        }
      }, themeStyle.border, surface]}>
          <_StyledDiv13 $_css14={[{
          "gridColumn": "1 / -1",
          "display": "flex",
          "flexWrap": "wrap",
          "alignItems": "center",
          "borderBottomWidth": "1px",
          "borderColor": "var(--stroke-primary)",
          "paddingLeft": "var(--spacing-xl)",
          "paddingRight": "var(--spacing-xl)",
          "paddingTop": "var(--spacing-lg)",
          "paddingBottom": "var(--spacing-lg)",
          "@media (min-width: 1024px)": {
            "gridColumn": "span 6 / span 6",
            "borderWidth": "0px",
            "paddingLeft": "var(--spacing-3xl)",
            "paddingRight": "var(--spacing-3xl)",
            "paddingTop": "17.6rem",
            "paddingBottom": "var(--spacing-xl)"
          }
        }]}>
            <_StyledDiv14>
              {headline && <_StyledHeadline2 text={headline} />}
            </_StyledDiv14>
          </_StyledDiv13>
          {(text || isLinkValid(cta)) && <_StyledDiv15>
              {text && <RichText text={text} />}
              {isLinkValid(cta) && <div>
                  <Button as={Link} {...cta} variant="underline" icon={linkIcon} />
                </div>}
            </_StyledDiv15>}
        </_StyledGrid2>
        {tags}
        {metadata}
        {hasItems(media) && <_StyledDiv16 data-theme="light" $_css15={[{
        "position": "relative",
        "borderTopWidth": "1px"
      }, surface, themeStyle.border]}>
            <_StyledDiv17 $_css16={[{
          "padding": "var(--spacing-md)",
          "@media (min-width: 1024px)": {
            "padding": "var(--spacing-xl)"
          }
        }, mediaLayoutVariants[mediaLayout as MediaLayout], themeStyle.border]}>
              <Media {...takeFirst(media)} imageProps={{
            ratio: "16/9",
            loading: "eager",
            priority: true
          }} inlineVideoProps={{
            ratio: "16/9",
            videoRef: videoRef,
            priority: true,
            controls: <_StyledVideoControls2 videoRef={videoRef} />
          }} externalVideoProps={{
            ratio: "16/9"
          }} />
            </_StyledDiv17>
          </_StyledDiv16>}
      </Wrap>
    </_StyledDiv10>;
}
export function SimpleHero(props: Props) {
  const layout = useFragment(fragment, props).layout || "full";
  const Component = layouts[layout as keyof typeof layouts];
  if (!Component) {
    return null;
  }
  return <Component {...props} />;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-mrn8ug-0"
})`${p => p.$_css}`;
var _StyledWrap = _styled2(Wrap).withConfig({
  componentId: "sc-sf-mrn8ug-1"
})({
  "borderRightWidth": "0px"
});
var _StyledGrid = _styled3(Grid).withConfig({
  componentId: "sc-sf-mrn8ug-2"
})`${p => p.$_css2}`;
var _StyledDiv2 = _styled4("div").withConfig({
  componentId: "sc-sf-mrn8ug-3"
})`${p => p.$_css3}`;
var _StyledDiv3 = _styled5("div").withConfig({
  componentId: "sc-sf-mrn8ug-4"
})`${p => p.$_css4}`;
var _StyledIcon = _styled6(Icon).withConfig({
  componentId: "sc-sf-mrn8ug-5"
})({
  "marginBottom": "0.2rem"
});
var _StyledDiv4 = _styled7("div").withConfig({
  componentId: "sc-sf-mrn8ug-6"
})`${p => p.$_css5}`;
var _StyledHeadline = _styled8(Headline).withConfig({
  componentId: "sc-sf-mrn8ug-7"
})({
  "fontSize": "2.4rem",
  "lineHeight": "1.2",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "3.2rem",
    "lineHeight": "1.2",
    "letterSpacing": "0.032rem",
    "fontWeight": "400"
  },
  "@media (min-width: 1800px)": {
    "fontSize": "3.8rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.038rem",
    "fontWeight": "400"
  }
});
var _StyledDiv5 = _styled9("div").withConfig({
  componentId: "sc-sf-mrn8ug-8"
})`${p => p.$_css6}`;
var _StyledDiv6 = _styled10("div").withConfig({
  componentId: "sc-sf-mrn8ug-9"
})({
  "gridColumn": "span 8 / span 8",
  "@media (min-width: 1280px)": {
    "gridColumn": "span 9 / span 9",
    "paddingRight": "var(--spacing-xl)"
  },
  "@media (min-width: 1536px)": {
    "gridColumn": "span 8 / span 8"
  }
});
var _StyledDiv7 = _styled11("div").withConfig({
  componentId: "sc-sf-mrn8ug-10"
})`${p => p.$_css7}`;
var _StyledDiv8 = _styled12("div").withConfig({
  componentId: "sc-sf-mrn8ug-11"
})`${p => p.$_css8}`;
var _StyledDiv9 = _styled13("div").withConfig({
  componentId: "sc-sf-mrn8ug-12"
})`${p => p.$_css9}`;
var _StyledVideoControls = _styled14(VideoControls).withConfig({
  componentId: "sc-sf-mrn8ug-13"
})({
  "position": "absolute",
  "right": "var(--spacing-md)",
  "top": "var(--spacing-md)",
  "zIndex": "10"
});
var _StyledDiv10 = _styled15("div").withConfig({
  componentId: "sc-sf-mrn8ug-14"
})`${p => p.$_css10}`;
var _StyledDiv11 = _styled16("div").withConfig({
  componentId: "sc-sf-mrn8ug-15"
})`${p => p.$_css11}`;
var _StyledDiv12 = _styled17("div").withConfig({
  componentId: "sc-sf-mrn8ug-16"
})`${p => p.$_css12}`;
var _StyledIcon2 = _styled18(Icon).withConfig({
  componentId: "sc-sf-mrn8ug-17"
})({
  "marginBottom": "0.2rem"
});
var _StyledGrid2 = _styled19(Grid).withConfig({
  componentId: "sc-sf-mrn8ug-18"
})`${p => p.$_css13}`;
var _StyledDiv13 = _styled20("div").withConfig({
  componentId: "sc-sf-mrn8ug-19"
})`${p => p.$_css14}`;
var _StyledDiv14 = _styled21("div").withConfig({
  componentId: "sc-sf-mrn8ug-20"
})({
  "display": "flex",
  "flexDirection": "column",
  "rowGap": "0.8rem"
});
var _StyledHeadline2 = _styled22(Headline).withConfig({
  componentId: "sc-sf-mrn8ug-21"
})({
  "fontSize": "2.4rem",
  "lineHeight": "1.2",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "3.8rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.038rem",
    "fontWeight": "400"
  }
});
var _StyledDiv15 = _styled23("div").withConfig({
  componentId: "sc-sf-mrn8ug-22"
})({
  "gridColumn": "1 / -1",
  "display": "flex",
  "flexDirection": "column",
  "justifyContent": "center",
  "rowGap": "var(--spacing-lg)",
  "paddingLeft": "var(--spacing-xl)",
  "paddingRight": "var(--spacing-xl)",
  "paddingTop": "var(--spacing-lg)",
  "paddingBottom": "var(--spacing-lg)",
  "@media (min-width: 1024px)": {
    "gridColumn": "span 6 / span 6",
    "paddingLeft": "var(--spacing-3xl)",
    "paddingRight": "var(--spacing-3xl)",
    "paddingTop": "17.6rem",
    "paddingBottom": "var(--spacing-xl)"
  }
});
var _StyledDiv16 = _styled24("div").withConfig({
  componentId: "sc-sf-mrn8ug-23"
})`${p => p.$_css15}`;
var _StyledDiv17 = _styled25("div").withConfig({
  componentId: "sc-sf-mrn8ug-24"
})`${p => p.$_css16}`;
var _StyledVideoControls2 = /*#__PURE__*/_styled26(VideoControls).withConfig({
  displayName: "simple-hero___StyledVideoControls2",
  componentId: "sc-13l36l2-0"
})({
  "position": "absolute",
  "right": "var(--spacing-md)",
  "top": "var(--spacing-md)",
  "zIndex": "10"
});